import { GridActionsCellItem, GridRowId } from "@mui/x-data-grid";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import axios, { AxiosError } from "axios";
import { links } from "../../../../utils/links";
import React from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Change, status } from "../../../../global/interfaces/Change";
import { CircularProgress } from "@mui/material";
import { enqueueSnackbar } from "notistack";
import { ErrorResponse } from "../../../../global/queries/usePostChangeQuery";

const ApproveActionCell = (props: { id: GridRowId }) => {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: (id: GridRowId) => {
      const local_jwt = localStorage.getItem("jwt");
      const headers = { Authorization: `Bearer ${local_jwt}` };
      return axios.put(`${links.approveAenderung}${id}`, {}, { headers });
    },
    onSuccess: () => {
      queryClient.setQueryData(["Changes"], (oldData: Change[] | undefined) => {
        if (oldData) {
          return oldData.map((change: Change) =>
            change.id === props.id
              ? { ...change, status: status.ACCEPTED }
              : change
          );
        }
      });
    },
    onError: (e) => {
      const error = e as AxiosError;
      const errorData = error?.response?.data as ErrorResponse;
      const errorMessage = errorData?.message || "Unknown error";
      enqueueSnackbar(`Ein Fehler ist aufgetreten: ${errorMessage}`, {
        variant: "error",
      });
      console.log(errorData);
    },
  });

  return (
    <>
      {mutation.isLoading ? (
        <CircularProgress />
      ) : (
        <GridActionsCellItem
          icon={<CheckCircleOutlineIcon color="primary" />}
          label="Akzeptieren"
          onClick={() => mutation.mutate(props.id)}
        />
      )}
    </>
  );
};

export default ApproveActionCell;
